<template>
  <modal
    class="wtVacation"
    :header-text="$t('modal.addVacation')"
    hide-footer="true"
    :width="45"
    @close="close()"
  >
    <div :class="$style.header">
      <div :class="$style.addDate">
        {{ $t('global.from') }}
        <date-picker
          v-model="startTime"
          type="date"
          value-type="format"
          :clearable="false"
          :format="'DD.MM.YYYY'"
        />
        {{ $t('global.to') }}
        <date-picker
          v-model="endTime"
          type="date"
          value-type="format"
          :clearable="false"
          :format="'DD.MM.YYYY'"
        />

        <button
          :class="$style.button"
          @click="addVacation()"
        >
          {{ $t('global.add') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
  import Vue from 'vue';
  import Modal from '@/components/common/modal/settings-modal.vue';
  import DatePicker from 'vue2-datepicker';
  import dayjs from 'dayjs';
  import VueToast from 'vue-toast-notification';
  import { addVacation } from '@/api/methods/settings';

  Vue.use(VueToast);

  export default {
    components: { Modal, DatePicker },
    props: ['contactId'],

    data: () => ({
      startTime: dayjs().format('DD.MM.YYYY'),
      endTime: dayjs().format('DD.MM.YYYY'),
    }),
    methods: {
      parseDate(dateString) {
        const [day, month, year] = dateString.split('.').map(Number);
        return new Date(year, month - 1, day);
      },
      async addVacation() {
        const startTime = this.parseDate(this.startTime);
        const endTime = this.parseDate(this.endTime);
        try {
          if (startTime > endTime) {
            Vue.$toast.open({
              message: this.$t('toast.vacationEndDateBeforeStartDate'),
              type: 'error',
            });
          } else {
            const { result, success } = await addVacation(this.contactId, this.startTime, this.endTime);
            const { id } = result[0];
            if (success) {
              Vue.$toast.open({
                message: this.$t('toast.vacationSuccessfullyAdded'),
                type: 'success',
              });
              this.$emit('add', id, this.startTime, this.endTime);
              this.$emit('close');
            } else {
              console.error(this.$t('toast.failedToAddVacation'), result);
              Vue.$toast.open({
                message: this.$t('toast.failedToAddVacation'),
                type: 'error',
              });
            }
          }
        } catch (error) {
          console.error(this.$t('toast.somethingWentWrong'), error);
          Vue.$toast.open({
            message: this.$t('toast.somethingWentWrong'),
            type: 'error',
          });
        }
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" module>
  .datepicker {
    cursor: pointer;
  }

  .datepickerPopup td {
    vertical-align: middle;
  }

  .header {
    display: flex;
    justify-content: center;
    margin: 20px;
  }
  .addDate {
    font-size: 17px;
    display: flex;
    gap: 10px;
    align-items: baseline;
  }
  .button {
    cursor: pointer;
    width: 90px;
    background: #2985bf;
    border: none;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    opacity: 1;
    height: 100%;
    transition: all 0.3 ease-in-out;
  }
  .button:hover {
    opacity: 0.8;
  }
  .button:active {
    background: rgb(73, 173, 106);
  }
</style>
